import { global } from '@planjs/utils';
var env = {};
var mode = process.env.mode || 'production';
var channel = process.env.channel;
// TODO 通过npm包导入无法动态导入，这里可以使用生成工具生成
if (mode === 'development') {
    if (channel === 'ee') {
        env = tryDefault(require('./env.development.ee'));
    }
    else {
        env = tryDefault(require('./env.development'));
    }
}
else if (mode === 'staging') {
    if (channel === 'ee') {
        env = tryDefault(require('./env.staging.ee'));
    }
    else {
        env = tryDefault(require('./env.staging'));
    }
}
else {
    if (channel === 'ee') {
        env = tryDefault(require('./env.production.ee'));
    }
    else if (channel === 'jd') {
        env = tryDefault(require('./env.production.jd'));
    }
    else if (channel === 'lv') {
        env = tryDefault(require('./env.production.lv'));
    }
    else {
        env = tryDefault(require('./env.production'));
    }
}
export default global['env'] = env;
function tryDefault(obj) {
    return obj.default || obj;
}
